import React, { useEffect, useRef, useState } from 'react';

//hooks
import UseAddUsersToGroupModal from './AddUsersToGroupModal.hooks';
import { simpleBarAutoScrollHandler } from  '@/helpers/SimpleBar';

//components
import ModalWrapper from '../../../ModalWrapper'
import BasicButton from  '@/components/elements/global/buttons/BasicButton/BasicButton';
import SimpleSearchInput from  '@/components/elements/search/simpleSearchInput';
import SimpleBar from 'simplebar-react';
import SimpleTable from  '@/components/elements/global/tables/SimpleTable/SimpleTable';

//styling
import "../../../../../css/orgSettings/userGroups/AddUsersToGroupModal.scss"



const AddUsersToGroupModal = ({showModal, hideModal} : {showModal: boolean, hideModal: () => void}) => {
    const {searchInputLabel, searchModalUsersString, setSearchModalUsersString, backButtonText, backButtonLabel, isModalLoading, noDataMessage, moreAvailable, getMoreUsers, userDataLength, tableContent, modalTitle} = UseAddUsersToGroupModal();
    const simpleBarRef = useRef();
    const [tableHeight, setTableHeight] = useState<number>(69);

    useEffect(() => {
        if(!isModalLoading ) {
            if(userDataLength > 0) {
                setTableHeight(getTableHeight())
            }
            else {
                setTableHeight(69);
            }
        }
    },[isModalLoading, userDataLength, tableContent?.rows?.length])

    function getTableHeight(): number {
        if(!tableContent.rows.length) {
            return  69
        }

        return tableContent.rows.length > 7 ? 324 : (tableContent.rows.length * 39) + 30
    }
    return (
        <ModalWrapper isOpen={showModal} onRequestClose={hideModal} className="orgsettings-add-new-group-modal" children={
            <div className="add-new-group-modal-content">
                <h1>{modalTitle}</h1>

                <div className='search-users-panel'>
                    <SimpleSearchInput ariaLabel={searchInputLabel} setSearchString={setSearchModalUsersString} searchString={searchModalUsersString} />
                </div>

                <SimpleBar className='add-users-to-group-simple-bar' style={{ maxHeight: 400 , margin: '12px 0 5px', border: '1px solid #e3e3e3', borderRadius:'4px', height: tableHeight, transition: '0.4s height'}} scrollableNodeProps={{  ref: simpleBarRef, onScroll: (e: React.UIEvent<HTMLElement>) => simpleBarAutoScrollHandler(e, !isModalLoading && moreAvailable, getMoreUsers) }}>
                    <SimpleTable
                        isLoading={isModalLoading && userDataLength === 0}
                        simpleTableContent={tableContent} 
                        noDataMessage={noDataMessage}
                        isInfiniteScroll={true}                                                                                                                                                 
                        infiniteScrollFetchCondition={isModalLoading && moreAvailable}
                    />
                </SimpleBar>

                <span className='buttons'>
                    <BasicButton content={backButtonText}  className={"back-button"}  ariaLabel={backButtonLabel} onButtonClick={hideModal} />
                </span>
            </div>
        }/>
    );  
}

export default AddUsersToGroupModal;